/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".filter-tags-autocomplete[_ngcontent-%COMP%]     .mat-chip-list-wrapper{margin-top:5px}"];
export { styles as styles };
